import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

import shareIcon from "../../../assets/images/share.png";
import closeIcon from "../../../assets/images/close.png";
import arrowIconWhite from "../../../assets/images/arrowIconWhite.png";

import Img from "../../../assets/images/sezione-05-popup-03-03-img-01.svg";

export default function MutualitaSostenibilita({ isOpen, onClose }) {
  const overlayRef = useRef(null);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose?.();
    if (isOpen) {
      document.body.classList.add("overflow-hidden");
      window.addEventListener("keydown", onKey);
    }
    return () => {
      document.body.classList.remove("overflow-hidden");
      window.removeEventListener("keydown", onKey);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const onShare = (popupId) => {
    const url = new URL(window.location.href);
    url.searchParams.set("popup", popupId);

    if (navigator.share) {
      navigator
        .share({ title: "Mutualità e sostenibilità", url: url.toString() })
        .catch(() => {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url.toString()).catch(() => {});
    }
  };

  return createPortal(
    <div
      ref={overlayRef}
      className="fixed inset-0 z-[2400] bg-black/50 backdrop-blur-[2px] flex items-center justify-center p-3 md:p-6"
      onMouseDown={(e) => { if (e.target === overlayRef.current) onClose?.(); }}
      role="dialog"
      aria-modal="true"
      aria-label="Mutualità e Sostenibilità"
    >
      <div
        className="relative w-full md:w-[1280px] bg-white max-h-[90vh] overflow-y-auto overscroll-contain"
        style={{ background: "#E7E3DF", WebkitOverflowScrolling: "touch" }}
        onMouseDown={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="sticky top-3 z-10 flex items-center gap-2 justify-end pr-3">
          <button
            onClick={() => onShare("MutualitaSostenibilita")}
            className="inline-flex h-9 w-9 items-center justify-center rounded-full text-[#0E3761] bg-white/90 border border-[#0E3761]/30 hover:bg-white transition"
            title="Condividi"
            aria-label="Condividi"
          >
            <img src={shareIcon} alt="" className="h-4 w-4" />
          </button>
          <button
            onClick={onClose}
            className="inline-flex h-9 w-9 items-center justify-center rounded-full text-[#0E3761] bg-white/90 border border-[#0E3761]/30 hover:bg-white transition"
            title="Chiudi"
            aria-label="Chiudi"
          >
            <img src={closeIcon} alt="Chiudi" className="h-4 w-4" />
          </button>
        </div>

        {/* Contenuto */}
        <div className="p-8">
          <h2 className="text-[#A3648F] text-[30px] md:text-[40px] font-normal">
            Mutualità e Sostenibilità
          </h2>

          <div className="mt-8 flex flex-col md:flex-row items-center md:items-start gap-8">
            {/* Immagine */}
            <img
              src={Img}
              alt=""
              className="w-full max-w-[420px] h-auto"
            />

            {/* Testo */}
            <p className="text-[#0E3761] text-[16px] md:text-[24px] leading-[1.1em]">
              Reale Group ispira il proprio agire al principio di{" "}
              <span className="font-bold">MUTUALITÀ</span> e persegue una{" "}
              <span className="font-bold">SOSTENIBILITÀ</span> integrata, operando ogni
              giorno al fianco del Socio/assicurato con i propri valori e l’esperienza
              delle sue persone, per generare intenzionalmente impatti positivi e
              misurabili nelle comunità in cui opera.
            </p>
          </div>

          {/* CTA */}
          <div className="mt-8">
            <a href="https://www.realegroup.eu/groupshare/0/IT/ListaReportsAndAccounts/87/BILANCIO%20CONSOLIDATO%20RG%202025.pdf#page=70" target="_blank">
              <button
                className="bt-secondary2 text-sm px-4 py-2"
              >
                <img
                  src={arrowIconWhite}
                  alt="Arrow"
                  className="inline-block mr-2 w-[20px] h-[20px]"
                />
                Consulta il Report - cap. 1 • par. 1.3.1.1
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}
